// TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// SCROLL-TO ANIMATION FOR ANCHOR LINKS
// FADE-IN-UP ELEMENTS ON SCROLL
// SLIDER (SWIPER JS)
// SLIDER (SLICK JS)
// PRODUCT PICKER
// NEWSLETTER PICKER



//
// =TOUCH OR NO-TOUCH, THAT IS THE QUESTION!
// --------------------------------------------------

// function isTouchDevice() {
//   return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
// }
// if (isTouchDevice() === true) {
//   $("body").toggleClass("touch");
// } else {
//   $("body").toggleClass("no-touch");
// }


//
// =SCROLL-TO ANIMATION FOR ANCHOR LINKS
// --------------------------------------------------

// $('.msdw-page-scroll').click(function() {
//   if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
//     var target = $(this.hash);
//     target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
//     if (target.length) {
//       var offsetValue = 0;
//       if ( window.innerWidth <= 767 ) {
//         offsetValue;
//         // console.log(offsetValue);
//       } else {
//         offsetValue = 59;
//         // console.log(offsetValue);
//       }

//       $('html,body').animate({
//         scrollTop: target.offset().top - offsetValue
//       }, 900);
//       return false;
//     }
//   }
// });


//
// =FADE-IN-UP ELEMENTS ON SCROLL
// --------------------------------------------------

const scroll = window.requestAnimationFrame;

function showOnScroll() {
  const elems = document.querySelectorAll('.msdw-animate');

  elems.forEach((el) => {
    const elPosition = el.getBoundingClientRect().top
    const elScreen = window.innerHeight / .9

    if (elPosition < elScreen) {
      el.classList.add('msdw-animated')
    }
  });

  scroll(showOnScroll);
}

showOnScroll();


//
// =SLIDER (SWIPER JS)
// --------------------------------------------------

// var swiper = new Swiper('.swiper-container', {
//   slidesPerView: 1,
//   loop: true,
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
// });


//
// =SLIDER (SLICK JS)
// --------------------------------------------------

// $('.msdw-slider-jacket').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   swipe: false,
//   arrows: false,
//   swipeToSlide: true,   // in case, 2 or more slides at a time
//   autoplay: true,       // if autoplay...
//   accessibility: false  // use this to avoid page jumping bug
// });

// $('.slick-prev').click(function() {
//   $('.msdw-slider-jacket').slick('slickPrev');
// });
//
// $('.slick-next').click(function() {
//   $('.msdw-slider-jacket').slick('slickNext');
// });

// UNSLICK
// If needed, here's a fix for window resizing
// $(window).on('orientationchange resize', function() {
//   $('.msdw-slider-jacket').slick('resize');
// });


//
// =PRODUCT PICKER
// --------------------------------------------------

// $(".product-detail-picker").click(function(e){
//   e.preventDefault();
//   var productIdNumber = $(this).attr('data-product-id');
//   window.jwsdwMediator.publish('openPicker', 'productDetailPicker', {'productId': productIdNumber});
// });


//
// =NEWSLETTER PICKER
// --------------------------------------------------

// var campaignId = 'familyAndFriends',
//     pickerTag = document.getElementById("openPicker"),
//     newsletterConfig = {},
//     baseUrl = jwsdwSettings.baseUrl;

// $.ajax({
//   type: 'GET',
//   url: baseUrl + '/Newsletter-getNewsletterConfig',
//   data: {
//     campaignId: campaignId
//   },
//   success: function(response) {
//     newsletterConfig = response
//   },
//   error: function(response) {
//     jwsdwApi.popup.showHttpError(response.status)
//   }
// });

// pickerTag.addEventListener("click", function(){
//   window.jwsdwMediator.publish('openPicker', 'newsletterSignupPicker', {
//     "campaign": newsletterConfig.id,
//     "introduction": newsletterConfig.introduction,
//     "disclaimerOne": newsletterConfig.disclaimerOne,
//     "disclaimerTwo": newsletterConfig.disclaimerTwo
//   });
// });
